import { List } from 'immutable';
import { Inline, Value } from 'slate';
import { Editor } from 'slate-react';

import { INLINE_TYPES } from './constants';
import {
	getLinkTypeFromHref,
	getLinkDataFromAction,
	LinkData,
	getLinkAction,
	getLinkUrlData,
} from '../../../../containers/Editor/utils/helpers';
import { LinkType } from '../../../../containers/Editor/constants';

interface InlineLinkData {
	href: string;
	action?: string;
}

export const getLinks = (inlines: List<Inline>) => (
	inlines.filter(({ type, text }: Inline) => type === INLINE_TYPES.a && !!text)
);

export const getLinkData = (inlines: List<Inline>, spreads: number[][]): LinkData | null => {
	const links = getLinks(inlines);

	if (!links.size) {
		return null;
	}

	const { data } = links.first();
	const type = getLinkTypeFromHref(data.get('href'), data.get('action'));
	const linkData = type === LinkType.url
		? getLinkUrlData(data.get('href'))
		: getLinkDataFromAction(data.get('action'), spreads);

	return linkData;
};

const getInlineLinkData = (linkData: LinkData): InlineLinkData => {
	if (linkData.type === LinkType.url) {
		return {
			href: linkData.data.href,
		};
	}

	return {
		href: 'javascript:void(0)',
		action: getLinkAction(linkData),
	};
};

const createLink = (editor: Editor, linkData: LinkData): void => {
	editor.wrapInline({
		type: INLINE_TYPES.a,
		data: getInlineLinkData(linkData),
	});
};

const removeLink = (editor: Editor): void => {
	editor.unwrapInline(INLINE_TYPES.a);
};

export const updateLink = (editor: Editor, editorValue: Value, linkData: LinkData): void => {
	const { inlines, selection } = editorValue;
	const links = getLinks(inlines);

	if (!links.size) {
		if (selection.isExpanded && linkData) {
			createLink(editor, linkData);
		}
	} else {
		links.forEach(({ key }: Inline) => {
			if (linkData) {
				editor.setNodeByKey(key, {
					type: INLINE_TYPES.a,
					data: getInlineLinkData(linkData),
				});
			} else {
				removeLink(editor);
			}
		});
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/links.ts